module.exports = __webpack_public_path__ + "media/section1BgMVideo.762c0a95.mp4";